// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-nav-item',
    // #endregion
    // #region Properties
    props: {
        page: {
            type: Object,
            required: false,
            default: {}
        },
        currentPage: {
            type: Object,
            required: false,
            default: {}
        },
    },
    data: () => ({
        isOpen: true
    }),
    // #endregion
    // #region Methods
    methods: {
        onExpand() {
            this.isOpen = !this.isOpen;
        },
    }
    // #endregion
});
// #endregion
